import styled from 'styled-components';

import { bgColor, black, orange, textGray } from '../../modules/colors';
import { fonts } from '../../modules/metrics';

const options = {
  size: {
    xs: '16',
    sm: '20',
    md: '24',
    lg: '40',
  },

  theme: {
    dark: black,
    light: bgColor,
    new: orange,
  },
};

export const Wrapper = styled.div`
  border-radius: 4px;
  background-color: ${(props) => options.theme[props.theme]};
  font-size: ${fonts.sm}px;
  color: ${textGray};
  width: ${(props) => options.size[props.size]}px;
  height: ${(props) => options.size[props.size]}px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  ${(props) => props.onClick && 'cursor:pointer;'}
  ${(props) =>
    props.shadow &&
    'box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);'}
`;

export const Notification = styled.div`
  background-color: ${orange};
  border-radius: 50%;
  width: 10px;
  height: 10px;
  position: absolute;
  top: -5px;
  right: -5px;
`;
